import { useMaskito } from '@maskito/react';
import mergeRefs from 'merge-refs';
import { ChangeEvent, useEffect } from 'react';
import { useFormContext } from 'react-hook-form';

import { FormType } from '~/pages/pay/ui/PayPage.scheme';
import { formatAmount } from '~/shared/lib/formatAmount';
import { CurrencyCode, MonetaryAmount } from '~/shared/types';
import { Divider } from '~/shared/ui/Divider/Divider';
import { Input } from '~/shared/ui/Input/Input';
import { InputField } from '~/shared/ui/InputField/InputField';
import { SbpIcon } from '~/shared/ui/SbpIcon/SbpIcon';

import { emailMask, fieldName } from '../../../../../../constants/paymentCard';
import { useLocalization } from '../../../../../../localization/localization';
import { OfferToggle } from '../../../../OfferToggle/OfferToggle';
import { SbpButton } from '../../../../SbpButton/SbpButton';
import { classNameInputSlave } from '../Form/Form.ui';

import {
  BottomContent,
  ButtonLabel,
  dividerClassName,
  offerToggleRootClassName,
  Root,
} from './FormRu.ui';

export const FormRu = ({ isLoading }: { isLoading: boolean }) => {
  const { t } = useLocalization();

  const {
    formState: { errors, isValid },
    register,
    getValues,
    setValue,
  } = useFormContext<FormType>();
  const amount = getValues('amount');

  const inputEmailMaskRef = useMaskito({ options: emailMask });
  const inputEmail = register(`ruData.${fieldName.EMAIL}`);
  const inputEmailRef = mergeRefs<HTMLInputElement>(
    inputEmail.ref,
    inputEmailMaskRef,
  );

  const emaiFieldError = errors.ruData?.[fieldName.EMAIL];
  const isInvalidInputEmail = !!emaiFieldError;

  // Очистка offer при размонтировании
  useEffect(() => {
    return () => setValue('offer', false);
  }, [setValue]);

  return (
    <Root>
      <Divider
        className={dividerClassName}
        label={t('Your email to receive the certificate')}
      />
      <InputField error={emaiFieldError?.message}>
        <Input
          {...inputEmail}
          aria-label={t('ownerEmailPlaceholder')}
          autoComplete="email"
          autoCorrect="off"
          label={t('emailLabel')}
          inputClassName={classNameInputSlave}
          isInvalid={isInvalidInputEmail}
          onInput={(event: ChangeEvent<HTMLInputElement>) => {
            event.target.value = event.target.value.toLowerCase();
            inputEmail.onChange(event);
          }}
          placeholder={t('emailPlaceholder')}
          ref={inputEmailRef}
        />
      </InputField>
      <OfferToggle
        {...register('offer')}
        rootClassName={offerToggleRootClassName}
      />
      <BottomContent>
        <SbpButton disabled={!isValid} isLoading={isLoading} type="submit">
          <ButtonLabel>
            {t('pay button', {
              amount:
                amount &&
                formatAmount({
                  amount: amount.majorValue as MonetaryAmount,
                  currency: amount.currency as CurrencyCode,
                }),
            })}
          </ButtonLabel>
        </SbpButton>

        <SbpIcon />
      </BottomContent>
    </Root>
  );
};
